export const GET_COMPANY_TAGS = `
query GetCompanyTags($companyId: ID!) {
  company(id: $companyId) {
    allCompanyTags {
      id
      isActive
      activatedAt
      createdAt
      updatedAt
      tag {
        id
        name
      }
    }
    companyClosedIntervals {
      id
      closedAt
      reopenedAt
      notes
      proofOfClosureDocumentUrls
      proofOfReopeningDocumentUrls
    }
  }
}
`;

export const GET_COMPANY_QUERY = `
query GetCompany($companyId: ID!, $customerPageOne: Int!, $associationNameOne: String!, $customerPageTwo: Int!, $associationNameTwo: String!, $numberPerPage: Int) {
  company(id: $companyId) {
    id
    petraId
    name
    tinNumber
    numberOfEmployees
    companySegment
    ssnitNumber
    rocNumber
    dateOfEstablishment
    companyInfoFileUploads{
      id
      url
      fileType
    }
    directors {
      firstName
      id
      lastName
      companies {
        id
        name
      }
      emails{
        address
      }
      phones {
        number
      }
    }
    merged
    mergedTo {
      id
      name
    }
    mergedFrom {
      id
      name
    }
    companyMergeLogs {
      id
      createdAt
      duplicateCompany {
        id
        petraId
        name
      }
    }
    relationshipManager{
      id
      name
    }
    companyPayoutAccounts {
      id
      name
      institutionName
      accountNumber
      accountType
      company {
        id
      }
      bankBranch {
        id
        name
        financialInstitution {
          id
          name
        }
      }
    }
    tags {
      id
      name
    }
    exclusionListTags {
      id
      name
    }
    industrySector {
        id
        name
    }
    trustee {
      id
      name
    }
    companyAddresses{
        id
        isPrimary
        isActive
        address {
          id
          streetName
          poBox
          city
          region
          isPostalBox
          country {
            id
            name
          }
        }
      }
      companyEmails{
        id
        isPrimary
        isActive
        email {
          id
          address
        }
      }
      companyPhones {
        id
        isPrimary
        isActive
        phone {
          id
          number
          type
        }
      }
    companyContacts {
        id
        emailAddress
        mobileNumber
        contactName
        mobileNumber
        documentUrl
        role
        contactLevels {
          id
          name
        }
        customer {
          id
          petraId
          ssnitNumber
          dateOfBirth
          fullname
          maritalStatus {
            id
            name
          }
          middleName
          firstName
          gender
          lastName
          country {
            id
            name
          }
          customerEmails {
            id
            email {
              id
              address
            }
            isPrimary
          }
          activeCustomerPhones {
            id
            phone {
              id
              number
              type
            }
            isPrimary
          }
        }
    }
    formerEmployees: paginatedResource(page: $customerPageTwo, associationName: $associationNameTwo){
      __typename
      ... on CustomersWithCount {
       count
       errors{
         description
         property
       }
       results{
         id
         firstName
         lastName
         petraId
       }
      }
    }
    currentEmployees: paginatedResource(page: $customerPageOne, associationName: $associationNameOne, numberPerPage: $numberPerPage){
      __typename
      ... on CustomersWithCount {
       count
       errors{
         description
         property
       }
       results{
         id
         firstName
         lastName
         petraId
       }
      }
    }
    companySubscriptions {
      id
      createdAt
      salesPerson {
        id
        name
      }
      companyVan {
        id
        van
        oldVan
        financialInstitution {
          id
          name
        }
      }
      vestingRule {
        id
        vestingType
        flatPercentage
        year0
        year1
        year2
        year3
        year4
        year5
        year6
        year7
        year8
        year9
        year10
        vestingDateType
      }
      customerVestingRules {
        id
        customerId
        vestingType
        flatPercentage
        vestingDateType
        customer {
          id
          firstName
          lastName
          petraId
        }
      }
      product {
        id
        name
        isActive
        fundCode
        assetMapId
      }
      companyLiens {
        id
        amount
      }
      contributionAllocationTypes
      companySubscriptionTags {
        id
        tag {
          id
          name
        }
      }
    }
    opportunities {
      id
      opportunityInteractions {
        id
        description
        interactionDate
        interactionMode {
        id
        name
        }
      }
      product {
        id
        name
      }
      signedApplicationForm {
        id
        url
      }
      directDebitAuthorizationForm {
        id
        url
      }
      vestingRuleDocument {
        id
        url
      }
      npraForm {
        id
        url
      }
      employeeDatasheet {
        id
        url
      }
    }
  }
}
`;

export const GET_COMPANY_NAME = `
query GetCompanyNameAndSegment($companyId: ID!) {
  company(id: $companyId) {
    id
    name
  }
}
`;

export const GET_COMPANY_SUBSCRIPTIONS = `
query GetCompanySubscriptions($companyId: ID!) {
  company(id: $companyId) {
    companySubscriptions {
      id
      createdAt
      salesPerson {
        id
        name
      }
      companyVan {
        id
        van
        oldVan
        financialInstitution {
          id
          name
        }
      }
      vestingRule {
        id
        vestingType
        flatPercentage
        year0
        year1
        year2
        year3
        year4
        year5
        year6
        year7
        year8
        year9
        year10
        vestingDateType
      }
      customerVestingRules {
        id
        customerId
        vestingType
        flatPercentage
        vestingDateType
        customer {
          id
          firstName
          lastName
          petraId
        }
      }
      product {
        id
        name
        isActive
        fundCode
        assetMapId
      }
      companyLiens {
        id
        amount
      }
      contributionAllocationTypes
      companySubscriptionTags {
        id
        tag {
          id
          name
        }
      }
    }
  }
}
`;

export const GET_COMPANY_NOTIFICATIONS = `
query GetCompany($companyId: ID!) {
  company(id: $companyId) {
    id
    petraId
    name
    notifierRecords {
      id
      notificationType
      status
      message
      recipient
      reference
      createdAt
      updatedAt
    }
  }
}
`;

export const GET_COMPANY_REDEMPTION_REQUESTS = `
query GetCompany($companyId: ID!) {
  company(id: $companyId) {
    id
    petraId
    name
    redemptionRequests {
      id
      redemptionType
      redemptionValue
      redemptionAmount
      state
      requestDate
      customerSubscription {
        product {
          id
          name
        }
      }
    }
  }
}
`;

export const GET_COMPANY_TRANSFER_REQUESTS = `
query GetCompany($companyId: ID!) {
  company(id: $companyId) {
    id
    petraId
    name
    transferRequests {
      id
      requestDate
      transferType
      transferStatus
      firstContributionDate
      trusteeScheme {
          id
          name
          trustee {
            id
            name
          }
      }
      fromProduct {
        id
        name
      }
      toProduct {
        id
        name
      }
      user {
        id
        name
      }
    }
  }
}
`;

export const SEARCH_COMPANY_BY_PETRAID = `
  query SearchCompany($q: String!) {
    findCompanyByPetraId(petraId: $q) {
      id
      name
      petraId
    }
  }
`;

export const GLOBAL_SEARCH_COMPANY = `
  query GlobalSearchCompany($q: String!, $page: ID!, $numberPerPage: ID) {
    companySearch(q: $q, page: $page, numberPerPage: $numberPerPage) {
      count
      results {
        id
        name
        petraId
        companyEmails {
          email {
            address
          }
          isPrimary
        }
        companyPhones {
          phone {
            number
          }
          isPrimary
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const MERGE_COMPANIES = `
  mutation MergeCompanies($mainId: ID!, $duplicateId: ID!, $newCompanyName: String) {
    mergeCompanies(mainId: $mainId, duplicateId: $duplicateId, newCompanyName: $newCompanyName) {
      result
      errors {
        property
        description
      }
      company {
        id
      }
    }
  }
`;

export const CREATE_COMAPANY_INTERACTION = `
  mutation CreateInteraction($companyId: ID!, $subCategoryId: ID!,  $userId: ID!, $description: String!, $activityDate: String, $sourceContactInformation: String!, $interactionSourceId: ID!, $interactionResolved: Boolean!, $interactionCategory: String!, $customerId: ID,  $createTicket: Boolean, $subscriberIds: [ID!], $sourceName: String, $assigneeId: ID, $ticketSubCategoryId: ID, $ticketDescription: String, $attachmentIds: [ID!], $complaintType: String ) {
    createCompanyInteraction(companyId: $companyId, subCategoryId: $subCategoryId, userId: $userId, description: $description, activityDate: $activityDate, sourceContactInformation: $sourceContactInformation, interactionSourceId: $interactionSourceId, interactionResolved: $interactionResolved, interactionCategory: $interactionCategory, customerId: $customerId, createTicket: $createTicket, subscriberIds: $subscriberIds, sourceName: $sourceName, assigneeId: $assigneeId, ticketSubCategoryId: $ticketSubCategoryId, ticketDescription: $ticketDescription, attachmentIds: $attachmentIds, complaintType: $complaintType){
      companyInteraction {
        id
        description
        interactionCategory
        sourceContactInformation
        status
        dueDate
        revertDate
        complaintType
        sourceName
        companyInteractionAttachments {
          id
          attachment {
            id
            url
            name
          }
        }
        customer {
          id
          firstName
          lastName
          fullname
          petraId
          gender
          customerEmails {
            email {
              id
              address
            }
          }
          activeCustomerPhones {
            phone {
              id
              number
              type
            }
          }
          country {
            id
          }
        }
        companyInteractionTickets {
          id
          ticket {
            id
            properties
            reference
            source
            url
            state
          }
        }
        notes {
          id
          description
          user {
            id
            name
          }
          createdAt
          updatedAt
        }
        company {
          id
          name
        }
        subCategory {
          id
          name
          longName
        }
        interactionSource {
          id
          name
        }
        user {
          id
          name
        }
      }
      errors {
          property
          description
      }
    }
  }
`;

export const UPDATE_COMPANY_INTERACTION = `
  mutation UpdateCompanyInteraction($id:ID!, $companyId: ID!, $subCategoryId: ID!,  $userId: ID!, $description: String!, $interactionSourceId: ID!, $revertDate: String,$sourceContactInformation: String, $comment: String!, $complaintType: String, $customerId: ID) {
    updateCompanyInteraction(id: $id, companyId: $companyId, subCategoryId: $subCategoryId, userId: $userId, description: $description, sourceContactInformation: $sourceContactInformation,interactionSourceId: $interactionSourceId, revertDate: $revertDate, comment: $comment, complaintType: $complaintType, customerId: $customerId){
      companyInteraction {
        id
        description
        status
        activityDate
        dueDate
        comment
        revertDate
        interactionCategory
        complaintType
        sourceContactInformation
        customer {
          id
          fullname
        }
        companyInteractionAttachments {
          id
          attachment {
            id
            url
          }
        }
        companyInteractionTickets {
          id
          ticket {
            id
            properties
            reference
            source
            url
            state
          }
        }
        notes {
          id
          description
          user {
            id
            name
          }
        }
        company {
          id
          name
        }
        subCategory {
          id
          name
          longName
        }
        interactionSource {
          id
          name
        }
        user {
          id
          name
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const GENERATE_COMPANY_STATEMENT = `
query GenerateCompanyStatement($startDate: String!, $endDate: String!, $companySubscriptionId: ID!) {
  generateCompanyStatement(startDate:$startDate, endDate:$endDate, companySubscriptionId:$companySubscriptionId) {
    url
    error
  }
}
`;

export const UPDATE_COMPANY_SUBSCRIPTION = `
 mutation updateCompanySubscription($companySubscriptionId: ID!, $salesPersonId: ID, $contributionAllocationTypes: [String!]){
  updateCompanySubscription(companySubscriptionId: $companySubscriptionId, salesPersonId: $salesPersonId, contributionAllocationTypes: $contributionAllocationTypes ) {
    companySubscription{
      id
      salesPerson{
        id
        name
      }
      contributionAllocationTypes
    }
    errors{
      description
      property
    }
  }
 }
`;

export const DELETE_COMPANY_SUBSCRIPTION = `
 mutation DeleteCompanySubscription($id: ID!){
  deleteCompanySubscription(id: $id ) {
    result
    errors{
      description
      property
    }
  }
 }
`;

export const GET_COMPANY_TICKETS = `
query GetCompany($companyId: ID!) {
  company(id: $companyId) {
    tickets{
      id
      reference
      properties
      url
      state
    }
  }
}
`;

export const COMPANY_SCHEDULES = `
query CompanySchedules($petraId: String!) {
  companySchedules(petraId: $petraId) {
    id
    contributionType
    contributionDates
    tier
    isValid
    createdAt
    matchProcessedAt
    totalAmount
    totalSalary
    taId
    scheme
  }
}
`;

export const COMPANY_PAYMENTS = `
query CompanyPayments($petraId: String!, $fundCode: String) {
  companyPayments(petraId: $petraId, fundCode: $fundCode) {
    id
    taId
    contributions
    transactionDate
    valueDate
    transactionAmount
    scheme
    returnedAt
    returnChequeNumber
    returnPaymentType
    returnedChequeNotified
  }
}
`;

export const ASSIGN_PORT_TO_COMPANY = `
  mutation AssignPortToCompany($portId:ID!, $companyId: ID! ) {
    assignPortToCompany(portId: $portId,  companyId: $companyId){
      company {
        port {
          id
          relationshipManager {
            id
            name
          }
          relationshipOfficer {
            id
            name
          }
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const GET_COMPANY_CONTACT_PERSONS = `
query CompanyContactPersons($companyId: ID!, $page: String!) {
  companyContactPersons(companyId: $companyId, page: $page) {
    count
    errors{
      description
    }
    results{
        id
        emailAddress
        mobileNumber
        contactName
        documentUrl
        mobileNumber
        role
        contactLevels {
          id
          name
        }
    }
  }
}
`;

export const GET_COMPANY_CHANGELOG = `
query GetCompanyChangeLog($companyId: ID!) {
  companyChangeLogs(companyId: $companyId) {
    auditItem
    createdAt
    user
    comment
    action
  }
}
`;

export const GET_COMPANY_CONTRIBUTIONS = `
  query getClientContributions($petraId: String!, $fundCode: String!, $page: Int!) {
    clientContributions(petraId: $petraId, fundCode: $fundCode, page: $page) {
      count
      results{
        clientPetraid
        dealDescription
        dealType
        priceDate
        shareClass
        totalAmount
        totalUnits
        transactionType
        mappings
      }
    }
  }
`;

export const GET_COMPANY_INTERACTIONS_QUERY = `
query GetCompanyInteractions($companyId: ID!, $page: String) {
  interactionsForCompany(companyId: $companyId, page: $page) {
    count
    results {
      id
        activityDate
        revertDate
        dueDate
        closedAt
        closedBy
        closureMetadata
        description
        complaintType
        status
        interactionCategory
        sourceName
        sourceContactInformation
        companyInteractionAttachments {
          id
          attachment {
            id
            url
            name
          }
        }
        interactionSource {
          id
          name
        }
        companyInteractionTickets {
          id
          ticket {
            id
            properties
            reference
            source
            url
            state
          }
        }
        customer {
          id
          firstName
          lastName
          fullname
          petraId
          gender
          customerEmails {
            email {
              id
              address
            }
          }
          activeCustomerPhones {
            phone {
              id
              number
              type
            }
          }
          country {
            id
          }
        }
        notes {
          id
          description
          user {
            id
            name
          }
          createdAt
          updatedAt
        }
        user {
          id
          name
        }
        subCategory {
          id
          name
          longName
        }
    }
    errors {
      property
      description
    }
  }
}
`;

export const ASSIGN_ATTACHMENT_TO_COMPANY_INTERACTION = `
  mutation AssignAttachmentsToCompanyInteraction($attachmentIds: [ID!]!, $companyInteractionId: ID!) {
    assignAttachmentsToCompanyInteraction(attachmentIds: $attachmentIds, companyInteractionId: $companyInteractionId) {
      companyInteraction {
        id
        activityDate
        status
        notes {
          id
          description
          user {
            id
            name
          }
        }
        companyInteractionAttachments {
          id
          attachment {
            id
            url
            name
          }
        }
        description
        user {
          id
          name
        }
        subCategory {
          id
          name
          longName
        }
        interactionSource {
          id
          name
        }
      }
    }
  }
`;

export const ASSIGN_NOTE_TO_COMPANY_INTERACTION = `
  mutation AssignNoteToCompanyInteraction($noteId: ID!, $companyInteractionId: ID!){
    assignNoteToCompanyInteraction(noteId: $noteId, companyInteractionId: $companyInteractionId) {
      companyInteractionNote {
        note {
          id
          description
          user {
            id
            name
          }
          updatedAt
          createdAt
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const CLOSE_COMPANY_INTERACTION = `
mutation CloseCompanyInteraction($companyInteractionId: ID!, $closureType: String, $templateId: ID, $sendSurvey: Boolean, $customComment: String) {
  closeCompanyInteraction(companyInteractionId: $companyInteractionId, closureType: $closureType, templateId: $templateId, sendSurvey: $sendSurvey, customComment: $customComment){
    companyInteraction {
      id
      status
      closedAt
      closedBy
      closureType
      closureMetadata
    }
    errors {
      property
      description
    }
  }
}
`;

export const HOLD_COMPANY_INTERACTION = `
mutation HoldCompanyInteraction($companyInteractionId: ID!) {
  holdCompanyInteraction(companyInteractionId: $companyInteractionId){
    companyInteraction {
      id
      status
    }
    errors {
      property
      description
    }
  }
}
`;

export const OPEN_COMPANY_INTERACTION = `
mutation OpenCompanyInteraction($companyInteractionId: ID!) {
  openCompanyInteraction(companyInteractionId: $companyInteractionId){
    companyInteraction {
      id
      status
    }
    errors {
      property
      description
    }
  }
}
`;

export const CREATE_COMPANY_TICKET = `
mutation createCompanyInteractionTicket($source: String!, $properties: JSON!, $companyInteractionId: String!, $assigneeId: ID, $ticketSubCategoryId: ID) {
  createCompanyInteractionTicket(source: $source, properties: $properties, companyInteractionId: $companyInteractionId, assigneeId: $assigneeId, ticketSubCategoryId: $ticketSubCategoryId){
    ticket {
      id
      properties
      reference
      source
      url
      state
    }
    errors {
      property
      description
    }
  }
}
`;

export const GET_COMPANY_INTERACTION_CHANGELOG = `
query CompanyInteractionChangeLogs($companyInteractionId: ID!) {
  companyInteractionChangeLogs(companyInteractionId: $companyInteractionId) {
    auditItem
    createdAt
    comment
    user
    comment
    action
  }
}
`;

export const SEARCH_COMPANY = `
query SearchCompany($q: String!, $page: ID!) {
  companySearch(q: $q, page: $page) {
    count
    results {
      id
      petraId
      name
      companyPhones {
        id
        phone {
          id
          number
          type
        }
        isPrimary
      }
      companyEmails {
        id
        isPrimary
        email {
          id
          address
        }
      }
      companySubscriptions {
        id
        company {
          id
          name
        }
        product{
          id
          name
          isActive
        }
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const COMPANY_INTERACTIONS_QUERY = `
query GetCompanyInteractions($page: ID!, $q: String!, $numberPerPage: Int) {
  companyInteractionSearch(page: $page, q: $q, numberPerPage: $numberPerPage) {
    count
    errors {
      description
      property
    }
    results {
      id
      description
      status
      activityDate
      dueDate
      closedAt
      closedBy
      closureMetadata
      interactionCategory
      sourceContactInformation
      companyInteractionAttachments {
        id
        attachment {
          id
          url
          name
        }
      }
      companyInteractionTickets {
        id
        ticket {
          id
          properties
          reference
          source
          url
          state
        }
      }
      notes {
        id
        description
        user {
          id
          name
        }
        createdAt
        updatedAt
      }
      company {
        id
        name
        petraId
      }
      subCategory {
        id
        name
        longName
      }
      interactionSource {
        id
        name
      }
      user {
        id
        name
      }
    }
  }
}
`;

export const GET_COMPANY_INTERACTION_QUERY = `
query GetCompanyInteraction($interactionId: ID!) {
  companyInteraction(id: $interactionId) {
      id
      activityDate
      comment
      dueDate
      closedAt
      closedBy
      closureMetadata
      description
      status
      interactionCategory
      complaintType
      sourceContactInformation
      companyInteractionAttachments {
        id
        attachment {
          id
          url
          name
        }
      }
      companyInteractionTickets {
        id
        ticket {
          id
          properties
          reference
          source
          url
          state
        }
      }

      notes {
        id
        description
        user {
          id
          name
        }
        createdAt
        updatedAt
      }
      company {
        id
        petraId
        name
      }
      user {
        id
        name
      }
      subCategory {
        id
        name
        longName
      }
      interactionSource {
        id
        name
      }
  }
}
`;

export const GET_COMPANIES = `
query {
  companies {
    id
    name
    petraId
  }
}
`;

export const GET_ARCHIVED_COMPANIES = `
query ArchivedCompanySearch($q: String!, $page: ID!, $numberPerPage: ID) {
  archivedCompanySearch(q: $q, page: $page, numberPerPage: $numberPerPage) {
    count
    results {
      id
      petraId
      name
      companyPhones {
        id
        phone {
          id
          number
          type
        }
        isPrimary
      }
      companyEmails {
        id
        isPrimary
        email {
          id
          address
        }
      }
      companySubscriptions {
        id
        company {
          id
          name
        }
        product{
          id
          name
        }
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const SEARCH_FORMER_EMPLOYEE = `
  query FindCompanyByPetraId($petraId: String!, $customerPageOne: Int!, $associationNameOne: String!, $q: String, $numberPerPage: Int) {
    findCompanyByPetraId(petraId: $petraId) {
      formerEmployees: paginatedResource(page: $customerPageOne, associationName: $associationNameOne, q: $q, numberPerPage: $numberPerPage){
        __typename
        ... on CustomersWithCount {
         count
         errors{
           description
           property
         }
         results{
           id
           firstName
           lastName
           petraId
         }
        }
      }
    }
    }`;

export const SEARCH_CURRENT_EMPLOYEE = `
  query FindCompanyByPetraId($petraId: String!, $customerPageTwo: Int!, $associationNameTwo: String!, $q: String, $numberPerPage: Int) {
    findCompanyByPetraId(petraId: $petraId) {
      currentEmployees: paginatedResource(page: $customerPageTwo, associationName: $associationNameTwo, q: $q, numberPerPage: $numberPerPage){
        __typename
        ... on CustomersWithCount {
         count
         errors{
           description
           property
         }
         results{
           id
           firstName
           lastName
           petraId
         }
        }
      }
   }
}`;

export const GET_COMPANY_STATEMENTS = `
    query GetCompanyStatements($companyId: ID!) {
      getCompanyStatements(companyId: $companyId) {
        dateSent
        emailSent
        period
        product
        statementType
        url
      }
    }
  `;

export const UPDATE_CONTACT_PERSON_MUTATION = `
  mutation UpdateContactPerson($firstName: String!, $lastName: String!, $gender: String!, $customerId: ID!, $countryId: ID!, $email: String, $titleId: ID) {
    updateContactPerson(firstName: $firstName, lastName: $lastName, gender: $gender, id: $customerId, countryId: $countryId, email: $email, titleId: $titleId){
      customer {
        id
      }
      errors {
        property
        description
      }
    }
  }
  `;

export const DELETE_CONTACT_PERSON_MUTATION = `
mutation DeleteCustomerCompanyAssociation($id: ID!) {
  deleteCustomerCompanyAssociation(id: $id){
    result
    errors {
      property
      description
    }
  }
}
`;

export const ASSIGN_ADDRESS_TO_COMPANY = `
  mutation AssignAddressToCompany( $addressId:ID!, $companyId:ID!) {
    assignAddressToCompany(addressId: $addressId, companyId: $companyId ){
      companyAddress {
        id
        isPrimary
        isActive
        address {
          id
          streetName
          poBox
          city
          region
          country {
            id
            name
          }
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const ASSIGN_EMAIL_TO_COMPANY = `
mutation AssignEmailToCompany( $emailId:ID!, $companyId:ID!) {
  assignEmailToCompany(emailId: $emailId, companyId: $companyId){
    companyEmail {
      id
      isPrimary
      isActive
      email {
        id
        address
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const ASSIGN_PHONE_TO_COMPANY = `
mutation AssignPhoneToCompany( $phoneId:ID!, $companyId:ID!) {
  assignPhoneToCompany(phoneId: $phoneId, companyId: $companyId){
    companyPhone {
      id
      isPrimary
      phone {
        id
        number
        type
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const UNASSIGN_ADDRESS_FROM_COMPANY = `
mutation UnassignAddressFromCompany($companyAddressId: ID!){
  unassignAddressFromCompany(id: $companyAddressId){
     companyAddresses {
        id
        isPrimary
        isActive
        address {
          id
          streetName
          poBox
          city
          region
          country {
            id
            name
          }
        }
      }
    errors {
      property
      description
    }
  }
}
`;

export const UNASSIGN_PHONE_FROM_COMPANY = `
mutation UnassignPhoneFromCompany($companyPhoneId: ID!){
  unassignPhoneFromCompany(id: $companyPhoneId){
      result
    errors {
      property
      description
    }
  }
}
`;

export const UNASSIGN_EMAIL_FROM_COMPANY = `
mutation UnassignEmailFromCompany($companyEmailId: ID!){
  unassignEmailFromCompany(id: $companyEmailId){
    result
    errors {
      property
      description
    }
  }
}
`;

export const UPDATE_COMPANY_MUTATION = `
mutation UpdateCompany($companyId: ID!, $name: String!, $tinNumber: String, $industrySectorId: ID, $petraId: String, $numberOfEmployees: Int, $trusteeId: ID, $relationshipManagerId: ID, $ssnitNumber: String, $rocNumber: String, $dateOfEstablishment: String, $companySegment: String) {
  updateCompany(id: $companyId, name: $name, tinNumber: $tinNumber, industrySectorId: $industrySectorId, petraId: $petraId, numberOfEmployees: $numberOfEmployees, trusteeId: $trusteeId, relationshipManagerId: $relationshipManagerId, ssnitNumber: $ssnitNumber, rocNumber: $rocNumber, dateOfEstablishment: $dateOfEstablishment, companySegment: $companySegment){
    company {
      id
      name
      tinNumber
      petraId
      numberOfEmployees
      ssnitNumber
      rocNumber
      companySegment
      dateOfEstablishment
      industrySector {
        name
      }
      trustee {
        name
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const MARK_COMPANY_ADDRESS_AS_PRIMARY = `
mutation MarkCompanyAddressAsPrimary($addressId: ID!) {
  markCompanyAddressAsPrimary(id: $addressId){
    companyAddresses {
      id
      address {
        id
        streetName
        poBox
        ghPost
        city
        region
        country {
          id
          name
        }
      }
      isPrimary
      isActive
    }
  }
}`;

export const MARK_COMPANY_EMAIL_AS_PRIMARY = `
mutation MarkCompanyEmailAsPrimary($emailId: ID!) {
  markCompanyEmailAsPrimary(id: $emailId){
    companyEmails {
      id
      email {
        id
        address
      }
      isPrimary
      isActive
    }
  }
}`;

export const MARK_COMPANY_PHONE_AS_PRIMARY = `
mutation MarkCompanyAddressAsPrimary($phoneId: ID!) {
  markCompanyPhoneAsPrimary(id: $phoneId){
    companyPhones {
      id
      phone {
        id
        number
        type
      }
      isPrimary
      isActive
    }
  }
}`;

export const ASSIGN_TAGS_TO_COMPANY_SUBSCRIPTION = `
mutation AssignTagsToCompanySubscription($tagIds: [ID!]!, $companySubscriptionId:ID!){
  assignTagsToCompanySubscription(tagIds: $tagIds, companySubscriptionId: $companySubscriptionId){
    companySubscription {
      companySubscriptionTags {
        tag {
          id
        }
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const UPDATE_COMPANY_ADDRESS = `
mutation UpdateCompanyAddress($companyAddressId: ID!, $companyId: ID!, $addressId: ID!) {
  updateCompanyAddress(id: $companyAddressId, companyId: $companyId, addressId: $addressId){
    companyAddress {
      company {
        companyAddresses {
          id
          address {
            id
            streetName
            poBox
            city
            region
            country {
              id
              name
            }
          }
          isPrimary
          isActive
        }
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const UPDATE_COMPANY_EMAIL = `
mutation UpdateCompanyEmail($companyEmailId: ID!, $companyId: ID!, $emailId: ID!) {
  updateCompanyEmail(id: $companyEmailId , companyId: $companyId, emailId: $emailId){
    companyEmail {
      company {
        companyEmails {
          id
          isPrimary
          isActive
          email {
            id
            address
          }
        }
      }
      email {
        id
      }
    }
    errors {
      property
      description
    }
  }
}`;

export const UPDATE_COMPANY_PHONE = `
mutation UpdateCompanyPhone($companyPhoneId: ID!, $companyId: ID!, $phoneId: ID!) {
  updateCompanyPhone(id: $companyPhoneId , companyId: $companyId, phoneId: $phoneId){
    companyPhone {
      company {
        companyPhones {
          id
          isPrimary
          phone {
            id
            number
            type
          }
        }
      }
      phone {
        id
      }
    }
    errors {
      property
      description
    }
  }
}`;

export const ASSIGN_TAGS_TO_COMPANY = `
mutation AssignTagsToCompany($companyId: ID!, $tagIds:[ID!]!, $effectiveDate: ISO8601DateTime, $notes: String, $proofOfClosureDocumentUrls: [String!], $proofOfReopeningDocumentUrls: [String!]){
  assignTagsToCompany(companyId: $companyId, tagIds: $tagIds, effectiveDate: $effectiveDate, notes: $notes, proofOfClosureDocumentUrls: $proofOfClosureDocumentUrls, proofOfReopeningDocumentUrls: $proofOfReopeningDocumentUrls){
    company {
      tags {
        id
        name
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const ADD_COMPANY_CLOSED_INTERVAL = `
mutation AddCompanyClosedInterval($companyId: ID!, $closedAt: ISO8601DateTime!, $reopenedAt: ISO8601DateTime!, $notes: String, $proofOfClosureDocumentUrls: [String!]!, $proofOfReopeningDocumentUrls: [String!]!){
  addCompanyClosedInterval(companyId: $companyId, closedAt: $closedAt, reopenedAt: $reopenedAt, notes: $notes, proofOfClosureDocumentUrls: $proofOfClosureDocumentUrls, proofOfReopeningDocumentUrls: $proofOfReopeningDocumentUrls){
    companyClosedInterval {
      id
      closedAt
      reopenedAt
      notes
      proofOfClosureDocumentUrls
      proofOfReopeningDocumentUrls
    }
    errors {
      property
      description
    }
  }
}
`;

export const DELETE_COMPANY_CLOSED_INTERVAL = `
mutation DeleteCompanyClosedInterval($id: ID!){
  deleteCompanyClosedInterval(id: $id){
    success
    errors {
      property
      description
    }
  }
}
`;

export const CREATE_CONTACT_PERSON_MUTATION = `
mutation CreateCompanyContact($companyId: ID!, $contactLevelIds: [ID!]!, $contactName: String, $emailAddress: String, $mobileNumber: String, $customerId: ID, $isExistingCustomer: Boolean!, $role: String, $documentUrl: String!) {
  createCompanyContact(companyId: $companyId, contactLevelIds: $contactLevelIds, contactName: $contactName, emailAddress: $emailAddress, mobileNumber: $mobileNumber, customerId: $customerId, isExistingCustomer: $isExistingCustomer, role: $role, documentUrl: $documentUrl){
    companyContact {
      id
      contactName
      emailAddress
      role
      mobileNumber
      documentUrl
      customer{
        id
      }
      contactLevels {
        id
        name
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const UPDATE_COMPANY_CONTACT_PERSON_MUTATION = `
mutation UpdateCompanyContact($id: ID!, $companyId: ID!, $contactLevelIds: [ID!]!, $contactName: String, $emailAddress: String, $mobileNumber: String, $customerId: ID, $role: String, $documentUrl: String!) {
  updateCompanyContact(id: $id, companyId: $companyId, contactLevelIds: $contactLevelIds, contactName: $contactName, emailAddress: $emailAddress, mobileNumber: $mobileNumber, customerId: $customerId, role: $role, documentUrl: $documentUrl){
    companyContact {
      id
      contactName
      emailAddress
      documentUrl
      mobileNumber
      role
      customer{
        id
      }
      contactLevels {
        id
        name
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const DELETE_COMPANY_CONTACT_PERSON_MUTATION = `
mutation deleteCompanyContact($id: ID!) {
  deleteCompanyContact(id: $id){
    result
    errors {
      property
      description
    }
  }
}
`;

export const ASSSIGN_COMPANY_QUERY_TO_OPPORTUNITY = `
mutation AssignCompanyQueryToOpportunity($companyName: String!, $opportunityId: ID!) {
  assignCompanyQueryToOpportunity(companyQuery: $companyName, opportunityId: $opportunityId){
    opportunity {
      companyQuery
    }
    errors {
      property
      description
    }
  }
}
`;

export const LOOKUP_COMPANY = `
  query LookupCompany($companyName: String!) {
    lookupCompany(companyName: $companyName) {
      id
      petraId
      name
    }
  }
`;

export const CREATE_COMPANY = `
mutation CreateCompany($name: String!) {
  createCompany(name: $name){
    company {
      id
      name
    }
    errors {
      property
      description
    }
  }
}
`;

export const ASSIGN_COMPANY_TO_OPPORTUNITY = `
  mutation AssignCompanyToOpportunity($companyId: ID!, $opportunityId: ID!) {
    assignCompanyToOpportunity(companyId: $companyId, opportunityId: $opportunityId){
      opportunity {
        company {
          id
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const SEARCH_COMPANY_SUMMARY = `
query SearchCompany($q: String!, $page: ID!) {
  companySearch(q: $q, page: $page) {
    count
    results {
      id
      petraId
      name
    }
  }
}
`;

export const GET_CLIENT_ACTIVITIES = `
query companyActivities($companyId: ID, $page: Int!, $q: String){
    companyActivities(companyId: $companyId, page: $page, q: $q){
        count
        results {
            summary
            id
            date
            completedOn
            status
            company{
              id
              name
            }
            service{
                id
                name
            }
            category{
                id
                name
            }
            subCategory {
                id
                name
            }
            companyActivityType{
                id
                name
            }
            assignee{
                id
                name
            }
            team {
                id
                name
                users{
                  id
                  name
                }
              }
        }
        errors{
            property
            description
          }
    }
}
`;

export const GET_FILE_OPTIONS_FOR_COMPANY = `
  query  {
    fileOptionsForCompany {
      key
      value
    }
  }
`;

export const SEARCH_COMPANY_LIST = `
query SearchCompany($q: String!, $page: ID!, $numberPerPage: ID) {
  companySearch(q: $q, page: $page, numberPerPage: $numberPerPage) {
    count
    results {
      id
      petraId
      name
      companyEmails {
      id
      email {
        id
        address
      }
      isPrimary
    }
    companyPhones {
      id
      phone {
        id
        number
        type
      }
      isPrimary
    }
      contactPersonValue
      companySubscriptions {
        id
        createdAt
        product {
          id
          name
          fundCode
          assetMapId
        }
      }
    }
    errors {
      property
      description
    }
  }
}
`;

export const GENERATE_QPR = `
  query DownloadOnePagerQpr($companyId: ID!, $productId: ID!, $quarter: String!, $year: String!) {
    downloadOnePagerQpr(companyId: $companyId, productId: $productId, quarter: $quarter, year: $year) {
      url
    }
  }
`;

export const CREATE_QPR_REPORT = `
mutation CreateQprReport($companyId: ID!, $qprType: String!, $productId: ID!, $quarter: String!, $year: String!, $notifyContactPeople: Boolean, $contactLevels: [String!]) {
  generateQprReport(companyId: $companyId, qprType: $qprType, productId: $productId, quarter: $quarter, year: $year, notifyContactPeople: $notifyContactPeople, contactLevels: $contactLevels) {
    qprReport {
      id
    }
    errors {
      property
      description
    }
  }
}
`;

export const INITIATE_QPR_PROCESS = `
  mutation InitiateQprProcess($productId: ID!, $year: String!, $quarter: String!, $qprType: String!, $notifyContactPeople: Boolean, $contactLevels: [String!], $companySegment: String) {
    initiateQprProcess(productId: $productId, year: $year, quarter: $quarter, qprType: $qprType, notifyContactPeople: $notifyContactPeople, contactLevels: $contactLevels, companySegment: $companySegment) {
      result
      errors {
        property
        description
      }
    }
  }
`;

export const GET_COMPANY_ACTIVITY_TYPES = `
query companyActivityTypes {
    companyActivityTypes{
    id
    name
  }
}
`;

export const CREATE_COMPANY_ACTIVITY = `
mutation CreateCompanyActivity($status: String!, $summary: String!, $date: ISO8601Date!, $completedOn: ISO8601DateTime, $companyActivityTypeId: ID!, $serviceId: ID!, $categoryId: ID!, $subCategoryId: ID!, $assigneeId: ID!, $teamId: ID!, $companyId: ID!) {
    createCompanyActivity(status: $status, summary: $summary, date: $date, completedOn: $completedOn, companyActivityTypeId: $companyActivityTypeId, serviceId: $serviceId, categoryId: $categoryId, subCategoryId: $subCategoryId, assigneeId: $assigneeId, teamId: $teamId, companyId: $companyId) {
        errors {
            description
            property
        }
        companyActivity {
            summary
            date
            completedOn
            companyActivityType{
                id
            }
        }
    }
}
`;

export const UPDATE_COMPANY_ACTIVITY = `
mutation UpdateCompanyActivity($id: ID! $status: String!, $summary: String!, $date: ISO8601Date!, $completedOn: ISO8601DateTime, $companyActivityTypeId: ID!, $serviceId: ID!, $categoryId: ID!, $subCategoryId: ID!, $assigneeId: ID!, $teamId: ID!, $companyId: ID!) {
    updateCompanyActivity(id: $id, status: $status, summary: $summary, date: $date, completedOn: $completedOn, companyActivityTypeId: $companyActivityTypeId, serviceId: $serviceId, categoryId: $categoryId, subCategoryId: $subCategoryId, assigneeId: $assigneeId, teamId: $teamId, companyId: $companyId) {
        errors {
            description
            property
        }
        companyActivity {
            summary
            date
            completedOn
            companyActivityType{
                id
            }
        }
    }
}
`;

export const REVERSE_MERGE_COMPANIES = `
  mutation ReverseMergeCompanies($mainId: ID!, $duplicateId: ID!) {
    reverseMergeCompanies(mainId: $mainId, duplicateId: $duplicateId) {
      result
      errors {
        property
        description
      }
      company {
        id
      }
    }
  }
`;

export const BULK_REVERSE_MERGE_COMPANIES = `
  mutation BulkReverseMergeCompanies($mainId: ID!, $duplicateIds: [ID!]) {
    bulkReverseMergeCompanies(mainId: $mainId, duplicateIds: $duplicateIds) {
      result
      errors {
        property
        description
      }
      company {
        id
      }
    }
  }
`;

export const CREATE_COMPANY_DIRECTOR = `
  mutation CreateCompanyDirector($companyId: ID!, $firstName: String!, $lastName: String!) {
    createCompanyDirector(companyId: $companyId, firstName: $firstName, lastName: $lastName){
      director {
        firstName
        id
        lastName
        companies {
          id
          name
        }
        emails{
          address
        }
        phones {
          number
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const CREATE_DIRECTOR_CONTACT = `
  mutation AddDirectorContact($directorId: ID!, $emailAddress: String, $phoneNumber: String) {
    addDirectorContact(directorId: $directorId, emailAddress: $emailAddress, phoneNumber: $phoneNumber) {
      director {
        firstName
        id
        lastName
        companies {
          id
          name
        }
        emails{
          address
        }
        phones {
          number
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const DELETE_DIRECTOR_CONTACT = `
  mutation RemoveDirectorContact($directorId: ID!, $emailAddress: String, $phoneNumber: String) {
    removeDirectorContact(directorId: $directorId, emailAddress: $emailAddress, phoneNumber: $phoneNumber) {
      director {
        firstName
        id
        lastName
        companies {
          id
          name
        }
        emails{
          address
        }
        phones {
          number
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const GET_COMPANY_DIRECTORS = `
query GetCompanyDirectors($companyId: ID!) {
  company(id: $companyId) {
    directors {
      firstName
      id
      lastName
      companies {
        id
        name
      }
      emails{
        address
      }
      phones {
        number
      }
    }
  }
}
`;

export const REMOVE_DIRECTOR = `
  mutation RemoveDirector($companyId: ID!, $directorId: ID!) {
    removeCompanyDirector(companyId: $companyId, directorId: $directorId){
      directors {
        firstName
        id
        lastName
        companies {
          id
          name
        }
        emails{
          address
        }
        phones {
          number
        }
      }
      errors {
        property
        description
      }
    }
  }
`;

export const UNASSIGN_ATTACHMENT_FROM_COMPANY_INTERACTION = `
  mutation unassignAttachmentFromCompanyInteraction($id: ID!) {
    unassignAttachmentFromCompanyInteraction(id: $id) {
      result
      errors {
        property
        description
      }
    }
  }
`;

export const GET_RETURNED_CHEQUE_NOTIFICATION_PREVIEW = `
  query GetReturnedChequeNotificationPreview($paymentId: ID!) {
    returnedChequeNotificationPreview(paymentId: $paymentId) {
      preview {
        templateName
        templateType
        notificationType
        recipient
        ccRecipients
        subject
        body
      }
      errors {
        property
        description
      }
    }
  }
`;

export const NOTIFY_RETURNED_CHEQUE = `
  mutation NotifyReturnedCheque($paymentId: ID!) {
    notifyReturnedCheque(paymentId: $paymentId) {
      queued
      errors {
        property
        description
      }
    }
  }
`;
